<script>
import Typeahead from "$lib/components/Typeahead.svelte";
import GeneralModal from "$lib/components/GeneralModal.svelte";
import {availableAddresses, storeAddress} from "$lib/calls/address";

export let project;

let showModal = false;

let newAddress = {}

let loading = false;
const postAddress = () => {
    loading = true;
    storeAddress(newAddress).then(fromServer => {
        loading = false;
        newAddress = fromServer;
        project.addressUuid = fromServer.id;
        showModal = false;
    })
}
</script>
<GeneralModal title="Neue Adresse" bind:showModal>
    <form on:submit|preventDefault={postAddress}>
        <div class="grid gap-3 grid-cols-5">
            <div class="input col-span-6">
                <label for="name">Name</label>
                <input id="name" type="text" bind:value={newAddress.name} required>
            </div>
            <div class="input col-span-4">
                <label for="street">Strasse</label>
                <input type="text" id="street" bind:value={newAddress.street} required>
            </div>
            <div class="input col-span-2">
                <label for="number">Nummer</label>
                <input type="text" id="number" bind:value={newAddress.number} required>
            </div>
            <div class="input col-span-3">
                <label for="place">Ort</label>
                <input type="text" id="place" bind:value={newAddress.place} required>
            </div>
            <div class="input col-span-3">
                <label for="zip">Postleitzahl</label>
                <input type="text" id="zip" bind:value={newAddress.zip} required>
            </div>
            <div class="input col-span-6">
                <label for="country">Land</label>
                <select bind:value={newAddress.country} id="country" required>
                    <option value="Deutschland">Deutschland</option>
                    <option value="Österreich">Österreich</option>
                    <option value="Schweiz">Schweiz</option>
                </select>
            </div>
            {#if loading}
                storing...
            {:else }
                <div class="col-span-6 place-self-end pt-5">
                    <button type="submit" class="place-self-end inline-flex items-center gap-x-2 rounded-md bg-primary-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-primary-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600">
                        <svg class="-ml-0.5 h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                            <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z" clip-rule="evenodd" />
                        </svg>
                        Speichern
                    </button>
                </div>
            {/if}

        </div>
    </form>
</GeneralModal>

{#if !loading}
    {#await availableAddresses()}
        Loading...
    {:then addresses}
    <h3 class="text-2xl  leading-7 text-neutral-600 mb-3 mt-4">Veranstaltungsort</h3>
    <div class="grid gap-3">
        <Typeahead
                icon="map-pin-alt-solid"
                value={addresses.find(x => x.uuid === project.addressUuid)?.name}
                label="Location" data={addresses} extract={selected => project.addressUuid = selected.uuid}
                let:item let:value>
            <div class="cursor-pointer">
                <div class="font-bold text-neutral-800">{item.name}</div>
                <div class="text-sm text-neutral-500">
                    {item.street} {item.number} <br>
                    {item.place}
                </div>
            </div>
            <svelte:fragment slot="no-results">
                <div class="flex gap-3 cursor-pointer" on:click={() => {newAddress.name=value; showModal = true}}>
                    <svg class="w-4 text-coolGray-500" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                    </svg>
                    <div>Adresse "<strong>{value}</strong>" anlegen.</div>
                </div>
            </svelte:fragment>
        </Typeahead>
        <div>
            {#if project.addressUuid}
                <iframe width="100%" height="300" id="gmap_canvas"
                        src={`https://maps.google.com/maps?q=${addresses.find(x => x.uuid === project.addressUuid)?.street.replace(/\s/, '%20')}%20${addresses.find(x => x.uuid === project.addressUuid)?.number}%20${addresses.find(x => x.uuid === project.addressUuid)?.place}%20${addresses.find(x => x.uuid === project.addressUuid)?.country}&t=&z=16&ie=UTF8&iwloc=&output=embed`}
                        frameborder="0" scrolling="no" marginheight="0" marginwidth="0">
                </iframe>
            {/if}
        </div>
    </div>
    {/await}
{:else}
    Loading...
{/if}